import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useApp from "../../hooks/useApp";
import "./styles.scss";

const DetailCard = ({
  data,
  heading = "",
  itemContainerStyle = {},
  itemLabelStyle = {},
  itemValueStyle = {},
  noLastItemContainerStyle = {},
}) => {
  const { selectedLanguage } = useApp();

  const location = useLocation();
  const { t } = useTranslation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  const getValue = (value) => {
    if (
      !value ||
      (typeof value === "string" && !value.trim()) ||
      value === "null"
    ) {
      return "--";
    }
    if (typeof value === "object") {
      return value[selectedLanguage?.value] ?? "--";
    }
    if (typeof value === "string") {
      if (value.includes("SAR")) {
        const numericString = value.replace(/[^\d.-]/g, "");
        const numericValue = parseFloat(numericString);
        return isNaN(numericValue) ? (
          value
        ) : (
          <div className="saudi-riyal-wrapper">
            <span className="icon-saudi_riyal"></span>
            <span>{numericValue.toLocaleString()}</span>
          </div>
        );
      }
    }
    return value;
  };

  return (
    <div className="account-info-card-container">
      {heading ? <p className="card-heading">{heading}</p> : null}
      {data &&
        data.map((item, index) => (
          <div
            key={index}
            className={`bd-item-container ${itemContainerStyle} ${
              index !== data.length - 1 ? noLastItemContainerStyle : ""
            }`}
          >
            <span className={`bd-item-label ${itemLabelStyle}`}>
              {typeof item.label === "object"
                ? item.label[selectedLanguage?.value]
                : t(`${routeName}.${item.label}`)}
            </span>
            <span className={`bd-item-value ${itemValueStyle}`}>
              { item.label === 'contact_number_label'
                ? t(`${routeName}.${'phone_number_only'}`, {
                  phoneNumber: item.value,
                })
                : getValue(item.value)
              }
            </span>
          </div>
        ))}
    </div>
  );
};

export default DetailCard;
